import { createMutationHook } from '~/shared/providers/api';

export const useCreateTransportationTypeMutation = createMutationHook(
  'transportation.transportationTypeCreate',
  (params: { name: string; description: string }) => ({
    transportationTransportationTypeCreate: {
      __args: {
        input: {
          name: params.name,
          description: params.description,
        },
      },
      id: true,
      name: true,
      description: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
